<template>
	<div class="brick">
		<div class="view_inner">
			<div class="divide_tbl">
				<table class="view_tbl" border="0">
					<colgroup>
						<col style="width:130px;" />
						<!-- <col style="width:400px;" /> -->
						<col style="" />
					</colgroup>
					<tbody>
						<tr>
							<th>Store Credit No</th>
							<td><input type="text" v-model="store_credit.sc_dn" class="tbl_int ssm2_int " readonly /></td>
						</tr>
						<tr>
							<th>Partner</th>
							<td>
								<div style="float:left;">
									<PartnerSelect v-model="store_credit.partner_code" :initialName="store_credit.partner_name" ph="Code" @set-partner="setPartner" />
								</div>
							</td>
						</tr>
						<tr>
							<th>Status</th>
							<td v-if="mode == 'detail'">
								<!-- {{ store_credit.status_code == 'R' ? 'Request' : store_credit.status_code == 'C' ? 'Confirmed' : 'Used' }} -->
								{{ store_credit.status_code | scStatusName }}
							</td>
						</tr>
						<tr>
							<th>Sales Person</th>
							<td>
								<CodeSelect className="tbl_select" :codes="salesGroups" v-model="store_credit.sales_group_code" />
							</td>
						</tr>

						<tr>
							<th>A/R Credit Type</th>
							<td>
								<CodeSelect className="tbl_select" :codes="arCreditTypeList" v-model="store_credit.ar_credit_type_code" />
							</td>
						</tr>

						<tr>
							<th>Entry User</th>
							<td>
								<input type="text" v-model.trim="store_credit.crt_user" class="tbl_int ssm2_int" readonly disabled />
								<template v-if="store_credit.upd_dt"> &nbsp;Last updated : {{ store_credit.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }} by {{ store_credit.upd_user }} </template>
								<template v-else-if="store_credit.confirm_date">, &nbsp;Confirmed : {{ store_credit.confirm_date | moment('MM-DD-YYYY') }} by {{ store_credit.confirmer_id }} </template>
							</td>
						</tr>
						<tr v-if="user.company_id == 'beautyplus' || user.company_id == 'hairplus'">
							<th>Packer</th>
							<td>
								<span v-if="mode == 'detail'">{{ store_credit.packer_name }}. Change To</span>
								<select class="tbl_select quarter_int" v-model="store_credit.packer_id">
									<option :value="null"></option>
									<!-- <option v-for="(staff, index) in wh_staff_list" :key="index" :value="staff.barcode">{{ staff.barcode }} | {{ staff.name }} ({{ staff.user_id }})</option> -->
									<option v-for="(staff, index) in wh_staff_list" :key="index" :value="staff.user_id">{{ staff.name }} ({{ staff.user_id }})</option>
								</select>
							</td>
						</tr>
						<tr>
							<th>Credit($)</th>
							<td>
								<currency-input type="text" v-model.trim="store_credit.amount" :precision="2" class="tbl_int ssm2_int al_right" :disabled="store_credit.status_code == 'U'" />
								<span v-if="user.company_id == 'hairplus'">(-)</span>
							</td>
						</tr>
						<tr>
							<th>Invoice No</th>
							<td>
								<input type="text" v-model.trim="store_credit.linked_invoice_dn" class="tbl_int ssm2_int" readonly disabled />
								S/O No :
								<SoSelect
									v-model.trim="store_credit.so_dn"
									:initialFromDaysAgo="180"
									initialStatusCode="I"
									ph="Enter SO No or Scan Barcode"
									:initialShipToCode="store_credit.partner_code"
									:link="true"
									@set-invoice="setInvoiceFromList"
									@search="search()"
									:disabled="!store_credit.partner_code"
								/>
							</td>
						</tr>

						<tr>
							<th>Credit Info</th>
							<td>
								<textarea style="padding:2px;" rows="30" v-model.trim="store_credit.info" class="textarea_type"></textarea>
							</td>
						</tr>
						<tr>
							<td colspan="2">
								<table>
									<tr>
										<td v-for="(file, index) in org_image_files" :key="index + 'org'" style="width: 180px; position: relative;">
											<a v-if="modifiable" href="javascript: void(0);" @click="deleteOrgImage(file)" style="position: absolute; top: 0px; right: 10px;">X</a>
											<img v-img :src="getImageUrl(file)" class="mgr_15" alt="File Not Found" style="cursor: zoom-in;max-height:130px;max-width:170px;height:auto;width:auto;" />
										</td>
										<td v-for="(file, index) in new_image_files" :key="index + 'new'" style="width: 180px; position: relative;">
											<a v-if="modifiable" href="javascript: void(0);" @click="deleteNewImage(file)" style="position: absolute; top: 0px; right: 0px;">X</a>
											<img v-img :src="getImageUrl(file)" class="mgr_15" alt="File Not Found" style="cursor: zoom-in;max-height:130px;max-width:170px;height:auto;width:auto;" />
										</td>
										<td v-if="modifiable" class="right_option">
											<button class="btn" @click="uploadFile()">Upload File</button>
											<input type="file" v-show="false" ref="uploadFile" class="file_input_hidden" accept="image/*" @change="uploadFileConfirm()" />
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="view_bottom_bt">
				<a v-if="modifiable && (store_credit.status_code == 'R' || store_credit.status_code == 'C')" href="javascript:;" type="button" class="search_bt mgr_15" @click="save()">Save</a>
				<a v-else-if="modifiable && store_credit.status_code == 'U'" href="javascript:;" type="button" class="search_bt mgr_15" @click="save()">Save Except Amount</a>

				<a v-if="modifiable && mode == 'detail' && user.sc_confirm && store_credit.status_code == 'R'" href="javascript:;" type="button" class="search_bt mgr_15" @click="confirm()">Confirm</a>
				<a v-if="mode === 'detail'" href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="print()">Print</a>

				<a v-if="modifiable && mode == 'detail' && store_credit.status_code == 'C'" href="javascript:;" type="button" class="search_bt mgr_15" @click="payment()">Make A/R Invoice</a>

				<a v-if="modifiable && mode == 'detail' && user.sc_confirm && (store_credit.status_code == 'R' || store_credit.status_code == 'C')" href="javascript:;" type="button" class="search_bt mgr_15" @click="withdraw()">Void</a>

				<a href="javascript:;" type="button" class="gray_bt mgl_15" @click="cancel()">Back</a>
			</div>
		</div>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectStoreCredit, apiInsertStoreCredit, apiUpdateStoreCredit, apiProcessPayment, apiSelectUsedARInvoice } from '@/api/partner/storecredit.js';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import SoSelect from '@/components/common/SoSelect';
// import Modal from '@/components/common/Modal';
//import Paging from '@/components/common/Paging';
//import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { today } from '@/utils/date.js';
import { reportMrtUrl, reportRenderBase64, apiUploadImage, apiDeletFilesByName } from '@/api/util';
import { apiSelectUserList } from '@/api/basicinfo/user.js';
//import { getPossibleStatus } from '@/main.js';

//import ItemClassSelect from '@/components/common/ItemClassSelect';
// import ItemPopup from '@/components/common/ItemPopup';
// import ReceiptPopup from '@/components/common/ReceiptPopup';
// import Modal from '@/components/common/Modal';

// import _ from 'lodash';

// import 'floatthead';
// import { apiGetReportTemplate, companyMrtUrl, objectToFormData, PrintType, Report } from '@/api/util';

export default {
	data: function() {
		return {
			backUri: '/sc/sc_main',

			mode: 'add',

			store_credit: {
				status_code: 'R',
			},

			salesGroups: [],
			arCreditTypeList: [],
			separator: '|',
			org_image_files: [],
			new_image_files: [],
			delete_files: [],

			wh_staff_list: [],
		};
	},
	computed: {
		// mainCandidateList() {
		// 	return this.prevInvoices.filter(i => i.invoice_type == 'S' && (i.status_code == 'A' || i.status_code == 'P' || i.status_code == 'W'));
		// },
		modifiable() {
			//if (this.store_credit.status_code != 'R') return false;

			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		user: function() {
			return this.$session.get('user');
		},
		// locationCountList: function() {
		// 	let locationCountList = [];

		// 	this.locationList.forEach(value => {
		// 		let obj = { name: value.name, count: 0 };
		// 		locationCountList.push(obj);
		// 	});
		// 	return locationCountList;
		// },
	},

	components: {
		PartnerSelect,
		CodeSelect,
		SoSelect,
	},
	methods: {
		async uploadFile() {
			const elem = this.$refs.uploadFile;
			elem.click();
		},
		async uploadFileConfirm() {
			var file = this.$refs.uploadFile.files[0];
			var { data } = await apiUploadImage(file);
			if (data.result) {
				this.new_image_files.push(data.filename);
				this.$refs.uploadFile.value = null;
				this.$toast.success('File uploaded successfully');
			}
		},
		getImageUrl(file) {
			return process.env.VUE_APP_API_URL + '/file/' + this.user.company_id + '/' + file;
		},
		deleteOrgImage(file) {
			let idx = this.org_image_files.findIndex(image => image === file);
			if (idx > -1) this.org_image_files.splice(idx, 1);

			this.delete_files.push(file);

			this.$toast.success('When Save Credit Info<br /> Image Will Be Deleted.');
		},
		deleteNewImage(file) {
			let idx = this.new_image_files.findIndex(image => image === file);
			if (idx > -1) this.new_image_files.splice(idx, 1);

			this.delete_files.push(file);

			this.$toast.success('When Save Credit Info<br /> Image Will Be Deleted.');
		},

		async payment() {
			//console.log(await this.checkUsed());
			if (await this.checkUsed()) return;
			else {
				if (await this.checkUsedInvoice()) return;
				this.$alertify.confirm('Are you sure to make A/R (Credit or Dept) Invoice?', () => {
					this.paymentConfirm();
				});
			}
		},
		async paymentConfirm() {
			var { data } = await apiProcessPayment(this.store_credit);
			if (data.result) {
				this.$toast.success('A/R Invoice made successfully');

				await this.selectStoreCredit();
			} else {
				this.$toast.error(data.msg);
			}
		},
		async setInvoiceFromList(invoice) {
			//console.log(invoice);
			this.store_credit.linked_invoice_no = invoice.invoice_no;
			this.store_credit.linked_invoice_dn = invoice.invoice_dn;
			// const { data } = await apiSelectInvoice({
			// 	invoice_no: invoice.invoice_no,
			// });
			// this.setInvoice(data.invoice);
		},
		setPartner(partner) {
			//console.log(partner);
			this.store_credit.partner_code = partner.code;
			if (this.mode == 'add') this.store_credit.sales_group_code = partner.sales_group_code;
		},

		async selectStoreCredit() {
			const { data } = await apiSelectStoreCredit({
				sc_no: this.store_credit.sc_no,
			});

			this.store_credit = data.store_credit;
			if (this.store_credit && this.store_credit.image_file_names) this.org_image_files = this.store_credit.image_file_names.split(this.separator);
			else this.org_image_files = [];
		},

		async print() {
			const { data } = await apiSelectStoreCredit({
				sc_no: this.store_credit.sc_no,
			});
			await reportRenderBase64(data, 'StoreCredit', reportMrtUrl('storeCredit'));
		},
		async checkUsedInvoice() {
			const { data } = await apiSelectUsedARInvoice({
				sc_dn: this.store_credit.sc_dn,
			});

			//console.log(data.store_credit);

			if (data.invoice && data.invoice.invoice_no > 0) {
				this.$toast.error('Already Used. Please contact system maintenance team.');
				return true;
			} else return false;
		},
		async checkUsed() {
			const { data } = await apiSelectStoreCredit({
				sc_no: this.store_credit.sc_no,
			});

			//console.log(data.store_credit);

			if (data.store_credit.status_code == 'U') {
				this.$toast.error('Already Used');
				return true;
			} else return false;
		},
		checkValidity() {
			if (!this.store_credit.sales_group_code) {
				this.$toast.error('Empty Sales Person');
				return false;
			}

			if (!this.store_credit.partner_code) {
				this.$toast.error('Empty Partner Code');
				return false;
			}

			if (this.user.company_id == 'hairplus' && !this.store_credit.ar_credit_type_code) {
				this.$toast.error('Empty A/R Credit Type');
				return false;
			}

			if (!this.store_credit.amount) {
				this.$toast.error('Empty Amount');
				return false;
			}

			return true;
		},

		async save() {
			if (this.mode == 'detai' && (await this.checkUsed())) return;

			if (this.checkValidity()) {
				await this.submit(false);
			}
		},
		async withdraw() {
			if (await this.checkUsed()) return;

			this.$alertify.confirm('Are you sure to make void?', () => {
				this.store_credit.status_code = 'W';
				this.submit(true);
			});
		},
		async confirm() {
			if (await this.checkUsed()) return;

			this.$alertify.confirm('Are you sure to confirm?', () => {
				this.store_credit.status_code = 'C';
				this.submit(true);
			});
		},
		cancel() {
			this.$router.push(this.backUri);
		},
		defineFileNamesForSubmit() {
			let image_file_names = '';
			if (this.org_image_files.length > 0) image_file_names += this.org_image_files.join(this.separator);
			if (this.new_image_files.length > 0) image_file_names += (image_file_names ? this.separator : '') + this.new_image_files.join(this.separator);

			this.store_credit.image_file_names = image_file_names || null;

			this.store_credit.delete_file_names = this.delete_files;
		},
		redefineFileArray() {
			// this.new_image_files.forEach(new_img => {
			// 	this.org_image_files.push(new_img);
			// });

			this.org_image_files = this.org_image_files.concat(this.new_image_files);

			this.new_image_files = [];
			this.delete_files = [];
		},
		async submit(status_changed) {
			this.defineFileNamesForSubmit();

			var response;
			if (this.mode == 'add') {
				response = await apiInsertStoreCredit(this.store_credit);
			} else {
				response = await apiUpdateStoreCredit(this.store_credit, status_changed);
			}
			var data = response.data;
			if (data.result) {
				this.$toast.success('Saved successfully');
				//console.log(this.backUri);
				if (this.mode == 'add') {
					this.store_credit.sc_no = data.sc_no;
					//this.store_credit.sc_dn = data.sc_dn;
					this.mode = 'detail';
					this.$store.commit('setSubTitle', 'Store Credit -> Detail');
				}

				this.redefineFileArray();
				await this.selectStoreCredit();
			} else {
				this.$toast.error(data.msg);
			}
		},

		async index() {
			const { data } = await apiIndex();

			this.salesGroups = data.salesGroupList;
			this.arCreditTypeList = data.arCreditTypeList;
		},
		async init() {
			await this.index();

			let { data } = await apiSelectUserList({
				active_yn: 'Y',
				user_type: 'whstaff',
				sort_key: 'user_name',
			});

			this.wh_staff_list = data.userList;
			// this.saleStatusCodes = this.$saleStatusCodes;

			// var response;

			if (this.mode == 'detail') {
				await this.selectStoreCredit();
				//console.log(getPossibleStatus(this.invoice.status_code));
				//this.saleStatusCodes = getPossibleStatus(this.invoice.status_code);
			}
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;
		this.mode = this.$route.params.mode;

		this.$store.commit('setSideIndex', 8);
		this.$store.commit('setSelectedMenu', 'nav_li_sc_main');

		if (this.mode == 'add') {
			this.$store.commit('setSubTitle', 'Store Credit -> Add');
			this.store_credit.request_date = today();
			//this.invoice.so_date = today();
		} else {
			this.$store.commit('setSubTitle', 'Store Credit -> Detail');
			this.store_credit.sc_no = this.$route.query.sc_no;

			if (!this.store_credit.sc_no) {
				//console.log('empty...', this.backUri);
				this.$router.push(this.backUri);
				return;
			}
		}

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
	beforeDestroy() {
		if (this.new_image_files.length > 0) apiDeletFilesByName(this.new_image_files);
	},
};
</script>

<style>
td a:hover {
	text-decoration: underline;
	color: #ff0000;
}
</style>
